module.exports = __webpack_public_path__ + "static/media/ic-copy-nobg.6875d610.svg";